import {
  Notification,
  NotificationsGroup,
} from 'components/Notifications/types';
import { signupStepsList } from 'containers/SignupPages/constants';
import { createSelector, createStructuredSelector } from 'reselect';
import { ProfileSettingsInfoType, UserSelectorType } from 'store/user/types';
import { EXCLUDED_TYPES } from 'utils/globalConst';

const getCin = (state: any) => state.getIn(['user', 'cin']);
const getLogin = (state: any) => state.getIn(['user', 'login']);
const getDrpp = (state: any) => state.getIn(['user', 'drpp']);
const getBday = (state: any) => state.getIn(['user', 'bday']);
const getEmail = (state: any) => state.getIn(['user', 'email']);
const getFirstName = (state: any) => state.getIn(['user', 'firstName']);
const getLastName = (state: any) => state.getIn(['user', 'lastName']);
const getphone = (state: any) => state.getIn(['user', 'phone']);
const getRoles = (state: any) => state.getIn(['user', 'roles']);
const getNotifications = (state: any) => state.getIn(['user', 'notifications']);
const getCurrentSignupStepName = (state: any) =>
  state.getIn(['user', 'currentSignupStepName']);
const getIsLoginLoading = (state: any) =>
  state.getIn(['user', 'isLoginLoading']);
const getIsLoading = (state: any) => state.getIn(['user', 'isLoading']);
const getErrorMessage = (state: any) => state.getIn(['user', 'errorMessage']);
const getToken = (state: any) => state.getIn(['user', 'token']);
const getPinId = (state: any) => state.getIn(['user', 'pinId']);
const getIsUserFound = (state: any) => state.getIn(['user', 'isUserFound']);
const getIsNotifEnabled = (state: any) =>
  state.getIn(['user', 'isNotifEnabled']);
const getLanguage = (state: any) => state.getIn(['user', 'language']);
const getIsUpdateProfileSettingsLoading = (state: any) =>
  state.getIn(['user', 'isUpdateProfileSettingsLoading']);
const getIsGetUserInfoLoading = (state: any) =>
  state.getIn(['user', 'isGetUserInfoLoading']);
const getIdentityImages = (state: any) =>
  state.getIn(['user', 'identityImages']);

export const mapNotificationResponsetoModel = (
  notifications: any,
): NotificationsGroup[] => {
  if (notifications.size === 0) return [];
  return Object.keys(notifications).map((item: any) => {
    return {
      month: item,
      notifications: notifications[item].map((element: any) => ({
        date: element?.created_at,
        read: element?.read,
        type: element?.type,
        group: item,
        message: element?.message.trim(),
        id: element?.id,
      })),
    };
  });
};

export const unReadNotificationsNumber = (
  notifications: NotificationsGroup[],
): number =>
  notifications.reduce(
    (prev: number, current: NotificationsGroup) =>
      prev +
      current.notifications.filter((item: Notification) => !item.read).length,
    0,
  );
export const notificationSelector = createSelector(getNotifications, (x) => x);

export const unReadNotificationsNumberSelector = createSelector(
  getNotifications,
  (notifications) => unReadNotificationsNumber(notifications),
);

const getIsLoginLoadingSelector = createSelector(
  getIsLoginLoading,
  (isLoginLoading) => isLoginLoading,
);

export const distinctsUniversFromRoles = (roles: any[]): string[] => {
  const allUnivers = [...new Set((roles || []).map((e: any) => e.type))];
  const userUnivers = (allUnivers as string[]).filter(
    (u: string) => !EXCLUDED_TYPES.includes(u),
  );
  return userUnivers;
};

export const hasUniversFunctionGenerator = (roles: any[]) => (
  univers: string,
) => distinctsUniversFromRoles(roles).includes(univers);

const hasUniversSelector = createSelector(
  getRoles,
  hasUniversFunctionGenerator,
);
const getDistinctUniversSelector = createSelector(
  getRoles,
  distinctsUniversFromRoles,
);

const getIsLoadingSelector = createSelector(
  getIsLoading,
  (isLoading) => isLoading,
);
const getRolesUserSelector = createSelector(getRoles, (roles) => roles);

const getCurrentSignupStepSelector = createSelector(
  getCurrentSignupStepName,
  (currentSignupStepName) => {
    if (currentSignupStepName) {
      const [currentStepObj] = signupStepsList.filter(
        ({ name }) => name === currentSignupStepName,
      );

      return currentStepObj;
    } else {
      return signupStepsList[0];
    }
  },
);

const getCurrentSignupStepNameSelector = createSelector(
  getCurrentSignupStepName,
  (currentSignupStepName) => currentSignupStepName,
);

const getErrorMessageSelector = createSelector(
  getErrorMessage,
  (errorMessage) => errorMessage,
);

const getEmailSelector = createSelector(getEmail, (email) => email);
const getLoginSelector = createSelector(getLogin, (login) => login);

const getTokenSelector = createSelector(getToken, (token) => token);

const getPhoneSelector = createSelector(getphone, (phone) => phone);

const getPinIdSelector = createSelector(getPinId, (pinId) => pinId);

const getIsUserFoundSelector = createSelector(
  getIsUserFound,
  (isUserFound) => isUserFound,
);

const getFirstNameSelector = createSelector(
  getFirstName,
  (firstName) => firstName,
);

const getIsUpdateProfileSettingsLoadingSelector = createSelector(
  getIsUpdateProfileSettingsLoading,
  (isUpdateProfileSettingsLoading) => isUpdateProfileSettingsLoading,
);

const userSelector = createStructuredSelector<any, UserSelectorType>({
  identifiant: getLogin,
  firstName: getFirstName,
  lastName: getLastName,
  cin: getCin,
  drpp: getDrpp,
  bday: getBday,
  email: getEmail,
  phone: getphone,
  roles: getRoles,
});

const profileSettingsInfo = createStructuredSelector<
  any,
  ProfileSettingsInfoType
>({
  firstName: getFirstName,
  lastName: getLastName,
  cin: getCin,
  email: getEmail,
  phone: getphone,
  bday: getBday,
  isNotifEnabled: getIsNotifEnabled,
  language: getLanguage,
});

export {
  getIsLoginLoadingSelector,
  getCurrentSignupStepSelector,
  getErrorMessageSelector,
  userSelector,
  getIsLoadingSelector,
  getCurrentSignupStepNameSelector,
  getEmailSelector,
  getTokenSelector,
  getLoginSelector,
  getPhoneSelector,
  getPinIdSelector,
  getIsUserFoundSelector,
  getFirstNameSelector,
  getRolesUserSelector,
  getDistinctUniversSelector,
  hasUniversSelector,
  profileSettingsInfo,
  getNotifications,
  getIsUpdateProfileSettingsLoadingSelector,
  getIsGetUserInfoLoading,
  getIdentityImages,
};
